import React from "react";
import Layout from "../Layout";
import Designation from "../create/Designation";
import Get from "../../../../services/Get";
import DimsDataTable from "../../../../components/DimsDataTable";
import helpers from "../../../../helpers/";
import DimsButton from "../../../../components/DimsButton";
class Designations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uuid: "",
      off: false,
      designationData: [],
    };
    this.toggleOffCanvas = this.toggleOffCanvas.bind(this);
    this.editClick = this.editClick.bind(this);
    this.load();
  }
  load() {
    var url = "/general/Designation";
    Get(url, "")
      .then((result) => {
        console.log(result);
        this.setState({ designationData: result.data });
      })
      .catch((error) => {
        helpers.error(error);
      });
  }
 
  toggleOffCanvas() {
    this.setState((prevState) => ({
      off: !prevState.off,
    }));
    this.load();
  }
  editClick(row) { 
    this.setState((prevState) => ({
      off: !prevState.off,
      uuid: row.guid,
    }));
  }
  render() {
    var columns = [
      {
        name: "Name",
        selector: (row) => row.name,
      },
      {
        name: "Description",
        selector: (row) => row.description,
      },
      {
        name: "",
        selector: (row) => (
          <div>
            <DimsButton
              type="edit"
              onClick={(e) => this.editClick(row)}
            ></DimsButton>{" "}
          </div>
        ),
      },
    ];
    return (
      <Layout title="Designation" isButton={true} url={this.toggleOffCanvas}>
        <Designation
          isOpen={this.state.off}
          uuid={this.state.uuid}
          toggle={this.toggleOffCanvas}
        ></Designation>
        <DimsDataTable data={this.state.designationData} columns={columns} />
      </Layout>
    );
  }
} 

export default Designations;